import './ecosystem-item.css';
import '../ecosystem.css';

export function EcosystemItem(props){
    
    const [logoimgurl, alttextlogoimg, text, buttonlinktext, buttonlinkurl] = props.data;

    return(
        <div className="ecosystem-item">
            <div className="ecosystem-item__logo-container">
                <img  src={logoimgurl} alt={alttextlogoimg} />
            </div>
            <div className="ecosystem-item__text-container"><p>{text}</p></div>
            <div className="ecosystem-item__link-container">
                <a href={buttonlinkurl}>{buttonlinktext}</a>
            </div>
        </div>
    );

}